import { Droplet } from "lucide-react";

/**
 * SanquaBadge — menandai properti sebagai mitra resmi Air Minum Sanqua.
 * Ditampilkan di web-site, kartu properti, dan halaman detail.
 */
export default function SanquaBadge({ size = "md", testid = "sanqua-badge", className = "" }) {
  const compact = size === "sm";
  return (
    <span
      data-testid={testid}
      title="Mitra Resmi Air Minum Sanqua"
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold border shadow-sm
        bg-sky-50 text-sky-700 border-sky-200 ${compact ? "text-[10px] px-2 py-0.5" : "text-xs px-3 py-1"} ${className}`}
    >
      <Droplet size={compact ? 11 : 14} className="fill-sky-500 text-sky-600 shrink-0" />
      {compact ? "Sanqua" : "Mitra Air Minum Sanqua"}
    </span>
  );
}
